import React from "react";

function About() {
  return (
    <div id="About">
      <hr></hr>
      <section className="about-container">
        {/* past presentations */}
        <div className="about-content">
          <h2>Past presentations</h2>
        </div>

        <div className="about-content">
          <div className="about-section">
            {/* <h1>Past Presentations</h1> */}
            <ul>
              <li>
                June 2023: the Global Online SHARP Conference, hosted by the
                Centre for the Book at the University of Otago, New Zealand and
                organized by the Society for the History of Authorship,
                Readership and Publishing (SHARP), "Affordances and Interfaces:
                Textual Interactions Past, Present and Future": "Renaissance
                Hyperlinks: Pope Julius II's Books amid Raphael's Paintings," a
                research lab session led by Andreas Kratky and Lisa Pon.
              </li>
              <br></br>
              <li>
                May 2023: the USC-Huntington Early Modern Studies Institute
                Seminar, "Paper and Other Early Modern Supports": "Unveiling the
                Bibliotheca Iulia Instaurata: Reading in a Renaissance Pope's
                Library," presented by Tracy Cosgriff at the Huntington Library,
                San Marino, CA.
              </li>
              <br></br>
              <li>
                March 2023: Tulane University’s annual Terry K. Simmons Lecture
                in Art History: "Pages, Plaster, and Computer Screens:
                Reimagining Raphael and the Library of Julius II," presented by
                Tracy Cosgriff and Lisa Pon, in New Orleans, LA.
              </li>
              <br></br>
              <li>
                February 2023: the annual conference of the California
                Interdisciplinary Consortium on Italian Studies (CICIS),
                "Hybrid: Digital Humanities and Italian Renaissance Art,"
                presented by Lisa Pon at California State University, Long
                Beach, CA.
              </li>
              <br></br>
              <li>
                June 2022: the Warburg Institute’s online workshop, "Between
                Technology and Theory: Digital Humanities Projects in Progress":
                "The Bibliotheca Iulia Instaurata," presented by Frederic Nolan
                Clark and Lisa Pon.
              </li>
              <br></br>
              <br></br>
            </ul>
          </div>
        </div>

        {/* team */}
        <div className="about-content">
          <h2>Project team</h2>
        </div>
        <div className="about-content">
          {/* team left column */}
          <div className="about-section">
            <h3>The Intellectual Historians</h3>
            <ul>
              <li>
                <a href="https://dornsife.usc.edu/profile/lisa-pon/">
                  Lisa Pon{" "}
                </a>
                (University of Southern California; Art History; PI)
              </li>
              <li>
                <a href="https://wooster.edu/bio/tcosgriff/">Tracy Cosgriff</a>{" "}
                (The College of Wooster; Art History; Co-PI)
              </li>
              <li>
                <a href="https://dornsife.usc.edu/profile/frederic-clark/">
                  Frederic Nolan Clark
                </a>{" "}
                (University of Southern California; Classics; Co-PI)
              </li>
            </ul>
            <br></br>

            <h3>Undergraduate Assistants</h3>
            <ul>
              <li>Olivia Benoit</li>
              <li>Isabelle Hoover</li>
            </ul>
            <br></br>

            <h3>Graduate Assistants in Interactive Media at USC</h3>
            <ul>
              <li>Yuwei Lin</li>
              <li>Jimi Stine</li>
              <li>Michael Wahba</li>
              <li>Hesi Mendez</li>
              <li>Jasmine Jupiter</li>
              <li>Christy Ye</li>
              <li>Jessica Dong</li>
              <li>Bernice Wang</li>
              <li>Shelby Zhang</li>
              <br></br>
              <br></br>
            </ul>
          </div>
          {/* team right column */}
          <div className="about-section">
            <h3>The Tech and Media Arts Team</h3>
            <ul>
              <li>
                <a href="http://www.andreaskratky.com/">Andreas Kratky </a>
                (University of Southern California; Media Arts + Practice;
                Co-PI)
              </li>
              <li>
                <a href="https://polymathic.usc.edu/person/curtis-fletcher">
                  Curtis Fletcher{" "}
                </a>
                (University of Southern California; Ahmanson Lab; Co-PI)
              </li>
              <li>
                <a href="https://erikloyer.com/">Erik Loyer </a>(University of
                Southern California; Annenberg Innovation Lab; Co-PI)
              </li>
            </ul>
            <br></br>

            <h3>Consultants and Advisors</h3>
            <ul>
              <li>Alexander Nagel</li>
              <li>David Lines</li>
              <li>Tara McPherson</li>
              <li>Francesca Fiorani</li>
              <li>Earle Havens</li>
              <li>Worthy Martin</li>
              <li>Arnold Nesselrath</li>
              <li>Margaret Haines</li>
              <li>Bill Sherman</li>
            </ul>
          </div>
        </div>

        {/* fundings */}
        <div className="about-content">
          <h2>Funding</h2>
        </div>

        <div className="about-content">
          <div className="about-section funding">
            {/* <h1>Funding</h1> */}
            <ul>
              <li>USC Ahmanson Lab Collaboratory (2019-20)</li>
              <li>
                USC Office of Research: Zumberge Collaboration Grants (2019,
                2020)
              </li>
              <li>
                NEH Digital Humanities Advancement Phase II Grant (Jan 2020-Dec
                2023)
              </li>
              <br></br>
              <br></br>
            </ul>
          </div>
        </div>

        {/* thanks */}
        <div className="about-content">
          <h4>
            <span style={{ fontSize: "18pt" }}>Thanks </span> to the Musei
            Vaticani; the Biblioteca Apostolica Vaticana; the Alliance for
            Networking Visual Culture; and Tallis Scholars/Gimell Records
          </h4>
        </div>
      </section>
    </div>
  );
}

export default About;
